import { Component, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { DragToCompleteComponent } from '../../billings/billing/drag-to-complete/drag-to-complete.component';
import { AraGenericDialogComponent } from '@shared/ui/ara-generic-dialog/ara-generic-dialog.component';
import { AraPanelComponent } from '@shared/ui/ara-panel/ara-panel.component';

/** Optionale Daten: Nutzeinheiten, in denen dieselbe Person ebenfalls Rollen hält. */
export interface DeleteRoleWarningDialogData {
	crossTenantUnitLabels?: string[];
}

@Component({
	selector: 'ara-delete-role-warning-dialog',
	imports: [AraGenericDialogComponent, TranslocoDirective, DragToCompleteComponent, AraPanelComponent],
	templateUrl: './delete-role-warning-dialog.component.html',
	styleUrls: ['./delete-role-warning-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	encapsulation: ViewEncapsulation.None,
})
export class DeleteRoleWarningDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<DeleteRoleWarningDialogComponent, boolean>);
	private readonly data: DeleteRoleWarningDialogData = inject(MAT_DIALOG_DATA, { optional: true }) ?? {};

	protected readonly crossTenantUnitLabels = this.data.crossTenantUnitLabels ?? [];

	close(): void {
		this.dialogRef.close(false);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
